
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Capa_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","width":"544","height":"677","viewBox":"0 0 544 676.4","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"logo-completo","fill":"#fff"}},[_c('path',{attrs:{"d":"M272 132.4c-150.2 0-272 121.8-272 272s121.8 272 272 272 272-121.8 272-272-121.8-272-272-272zm0 475.7c-112.5 0-203.7-91.2-203.7-203.7S159.5 200.7 272 200.7s203.7 91.2 203.7 203.7S384.5 608.1 272 608.1zM68.5 0h407.1v66.8H68.5z"}})])])
          )
        }
      }
    